import { useEffect, useRef } from 'react';

export const useResizeObserver = <T extends HTMLElement>({
	target,
	callback
}: {
	target: React.RefObject<T> | T | null;
	callback: ResizeObserverCallback;
}) => {
	const currentEl = target && 'current' in target ? target.current : target;
	const observer = useRef(null);

	useEffect(() => {
		if (observer && observer.current && currentEl) {
			observer.current.unobserve(currentEl);
		}

		observer.current = new ResizeObserver(callback);
		observe();

		return () => {
			if (observer && observer.current && currentEl) {
				observer.current.unobserve(currentEl);
				observer.current.disconnect();
			}
		};
	}, [currentEl]);

	const observe = () => {
		if (currentEl && observer.current) {
			observer.current.observe(currentEl);
		}
	};
};
